import React from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter, Routes, Route, Navigate, NavLink, useNavigate } from 'react-router-dom'
import './index.css'
import { auth, api } from './lib/api'
import Login from './pages/Login'
import Orders from './pages/Orders'
import Staff from './pages/Staff'
import Stats from './pages/Stats'

function Layout({ children }) {
  const nav = useNavigate()
  const staff = auth.staff
  const roleLabel = { admin: '管理员', leader: '售后组长', agent: '售后专员' }[staff?.role] || ''

  async function logout() {
    await api.logout().catch(() => {})
    auth.clear()
    nav('/login')
  }

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-brand">ETC 售后后台</div>
        <nav className="sidebar-nav">
          {auth.isAdmin && <NavLink to="/staff">员工列表</NavLink>}
          <NavLink to="/orders">订单列表</NavLink>
          <NavLink to="/stats">统计</NavLink>
        </nav>
      </aside>
      <div className="main">
        <div className="topbar spread">
          <div className="row">
            <strong>{staff?.name}</strong>
            <span className="tag">{roleLabel}</span>
          </div>
          <button className="btn btn-sm" onClick={logout}>退出登录</button>
        </div>
        <div className="content">{children}</div>
      </div>
    </div>
  )
}

function Guard({ children, adminOnly }) {
  if (!auth.token) return <Navigate to="/login" replace />
  if (adminOnly && !auth.isAdmin) return <Navigate to="/orders" replace />
  return <Layout>{children}</Layout>
}

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/orders" element={<Guard><Orders /></Guard>} />
        <Route path="/staff" element={<Guard adminOnly><Staff /></Guard>} />
        <Route path="/stats" element={<Guard><Stats /></Guard>} />
        <Route path="*" element={<Navigate to="/orders" replace />} />
      </Routes>
    </HashRouter>
  )
}

createRoot(document.getElementById('root')).render(<App />)
